<script setup lang="ts">
const { menuToggle } = useMenu()
const isMenuVisible = useState('menu')
</script>

<template>
  <button
    type="button"
    class="group fixed right-2 top-2 mx-auto h-10 w-10 cursor-pointer self-center bg-transparent mix-blend-difference invert lg:hidden"
    :aria-label="isMenuVisible ? 'Show menu' : 'Hide menu'"
    @click="menuToggle"
  >
    <span class="absolute left-1/2 top-1/2 block -translate-x-1/2 -translate-y-1/2">
      <span
        v-for="idx in 3"
        :key="idx"
        class="my-[3px] block h-px w-4 origin-center transform-gpu bg-black transition-transform delay-75 duration-300"
        :class="{
          'translate-y-1 rotate-[135deg]': isMenuVisible && idx === 1,
          'scale-0': isMenuVisible && idx === 2,
          '-translate-y-1 -rotate-[135deg]': isMenuVisible && idx === 3
        }"
      />
    </span>
  </button>
</template>
